import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useGentian from '../../core/hooks/useGentian';
import { isReseller } from '../../Utils/account.utils';
import { DebtLimitManager } from '../../Components/DebtLimit';

const releases = [
  {
    date: 'June 20, 2024',
    changes: [
      'Added survey request feature',
      'Implemented results feature',
      'Improved mobile responsiveness',
      'Disabled editing on click',
      'Updated terms and privacy info',
      'Added error logging',
    ],
  },
  {
    date: 'July 12, 2024',
    changes: [
      'UI adjustments and layout refinements',
      'Improved mobile responsiveness (continued)',
      'Header component updates',
      'Bug fixes and error logging improvements',
      'Small tweaks and styling updates',
    ],
  },
  {
    date: 'October 24, 2024',
    changes: [
      'Bug fixes: login and AOI upload restrictions',
      'Added AOI download button',
      'Added notes on results screen',
      'Projects page introduced (feature flag OFF)',
    ],
  },
  {
    date: 'June 2, 2025',
    changes: [
      'Completed dashboard and project page',
      'Shared shapefile improvements',
      'Improved login permission handling',
      'Commenting on individual shapes',
      'True Sight fully automated integration and progress updates',
      'AOI border and UK rule restrictions',
      'True Sight 40ha limit and purchase validation',
      'FAQs page and improved UI/UX',
      'Numerous bug fixes and layout improvements',
      'Payment fixes and deployment stability',
      'Added biodiversity units for hedgerows/watercourses',
      'Added report button to results',
      'Updated fonts, colors styles and logo',
      'Added release notes page',
      'Updated terms and conditions and end user license agreement',
    ],
  },
  {
    date: 'October 23, 2025',
    changes: [
      'Added platform client integration for improved system connectivity',
      'Introduced configuration options to pricing table',
      'Implemented new automation fields for streamlined workflows',
      'Automatic notifications for customers exceeding 40ha',
      'Initial tests and GitHub Actions added for CI stability',
      'Updated internal keys and configurations for enhanced security',
      'Major frontend refactor for better performance and reliability',
      'Added Cypress automated tests across key workflows',
      'Fixed dashboard issues and dialogue warnings',
      'Introduced pricing display and downloadable PDF links',
      'Redirected users from development environments to production',
      'Integrated Microsoft Analytics for improved platform insights',
      'General stability improvements, UI polish, and bug fixes',
      'True Sight product allows any size AOI purchases',
    ],
  },
];

const ReleaseNotesPage = () => {
  const { data: account } = useGentian().useAccount();
  const userId = account?.data?.user_id as string | undefined;
  const reseller = isReseller(account);
  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4, p: 2 }}>
      {reseller ? (
        <Typography variant="h4" gutterBottom>
          Release Notes Reseller
        </Typography>
      ) : (
        <Typography variant="h4" gutterBottom>
          Release Notes
        </Typography>
      )}
      {/* {userId && <DebtLimitManager userId={userId} />} */}

      {releases.map((release, index) => (
        <Accordion key={index}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">{release.date}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ul>
              {release.changes.map((change, i) => (
                <li key={i}>
                  <Typography variant="body1">{change}</Typography>
                </li>
              ))}
            </ul>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default ReleaseNotesPage;
